let $ = jQuery.noConflict(),
	devMode,
	body,
	mobileCheck = false,
	currentY,
	scrollBar,
	firstLoad = true,
	pageTransition,
	pageTransitionEnabled = false,
	barbaInitialized,
	resizeCallbacks = [],
	mobileResizeCallbacks = [],
	barbaCallbacks = [];

$(function () {
	initStarterKit();

	// Composants Mobile & Desktop
    // new CTA();
    new Expertise();
    new GridIsotope();
    new Navigation();
    new Timeline();
    new SingleEstate();
    new Contact();
	new CustomMap();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}
});

function initStarterKit() {
	body = $('body');
	mcubeDebug();
	mobileCheck = new MobileCheck();
	new ResizeEvents();
	// new SmoothScroll();
	// barbaInitialized = new InitBarba(); // Décommenter pour activer barba JS
	pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new AppearOnScroll();
	new DataLink();
	new Forms();
	new GDPR();
	// new InitMatchHeight();
	new MadeByMcube();
	new Parallax();
	new TextAppear();
}

function scrollListener(newY) {

}
